import { render } from "./app-footer-spouse.vue?vue&type=template&id=e1a1eb30&scoped=true&ts=true"
import script from "./app-footer-spouse.vue?vue&type=script&lang=ts"
export * from "./app-footer-spouse.vue?vue&type=script&lang=ts"

import "./app-footer-spouse.vue?vue&type=style&index=0&id=e1a1eb30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1a1eb30"]])

export default __exports__